import type { AppDefinition } from '@/types/app';
import { SqliteRecordStore } from '@/backend/stores/SqliteRecordStore';
import { useDeploymentStore } from '@/store/deploymentStore';
import { isDemoAppId } from '@/demos/registry';

const store = new SqliteRecordStore();

/**
 * Loads the AppDefinition for a published app. In AWS mode it fetches the catalog
 * detail (public, no auth); in mock mode it reads the definition the mock persisted
 * at publish time from local SQLite.
 */
export async function loadPublishedDefinition(appId: string): Promise<AppDefinition | null> {
  // Bundled demos live only in local SQLite (seeded on launch); never fetch them from the server.
  if (isDemoAppId(appId)) {
    const app = await store.getApp(appId);
    return app ? (app.definition as AppDefinition) : null;
  }
  const config = useDeploymentStore.getState().config;
  if (config?.mode === 'aws' && config.apiBaseUrl) {
    try {
      const res = await fetch(`${config.apiBaseUrl}/apps/${appId}`);
      if (!res.ok) return null;
      const data = (await res.json()) as { definition?: AppDefinition };
      return data.definition ?? null;
    } catch {
      return null;
    }
  }
  const app = await store.getApp(appId);
  return app ? (app.definition as AppDefinition) : null;
}
